//Display line item TBYB modifications for Rebuy cart
function modifyCartPricesAndTotal() {
  var cartList = document.querySelector(".rebuy-cart__flyout-items");

  if (cartList) {
    var cartItems = cartList.querySelectorAll("li");
    var total = 0;
    // Check if we have any tbyb items
    var skip = true;
    cartItems.forEach(function (li, index) {
      var itemProperties = li.querySelectorAll('.rebuy-cart__flyout-item-property');
      var containsTryBeforeYouBuy = false;

      itemProperties.forEach(function (property) {
        if (property.textContent.includes('Try Before You Buy')) {
          skip = false;

          // Reselect if subscription is selected
          if (li.querySelector('.rebuy-select').value === 'Every 1 month') {
            li.querySelector('.rebuy-select').value = 'onetime';
            li.querySelector('.rebuy-select').click();
          }
        }
        if (property.textContent.includes('Every')) {
          property.textContent = '';
        }
      });
    });
    if (skip) {
      return;
    }
    cartItems.forEach(function (li, index) {
      var itemProperties = li.querySelectorAll('.rebuy-cart__flyout-item-property');
      var containsTryBeforeYouBuy = false;

      itemProperties.forEach(function (property) {
        if (property.textContent.includes('Try Before You Buy')) {
          containsTryBeforeYouBuy = true;
        }
      });
      if (containsTryBeforeYouBuy) {
        if (typeof variable === 'undefined') {
          depositPercentage = 10;
        }
        var priceElement = li.querySelector('.rebuy-cart__flyout-item-price span.rebuy-money span:nth-child(2)');
        var finalLinePrice = Rebuy.SmartCart.items(0)[index].final_line_price / 100;
        var depositAmountNumeric = finalLinePrice * depositPercentage / 100;
        
        priceElement.textContent = Rebuy.SmartCart.formatMoney(depositAmountNumeric) + " (" + Rebuy.SmartCart.formatMoney(finalLinePrice) + " if kept)";
        total = total + depositAmountNumeric;
      } else {
        var priceElement = li.querySelector('.rebuy-cart__flyout-item-price span.rebuy-money span:nth-child(2)');
        var finalLinePrice = Rebuy.SmartCart.items(0)[index].final_line_price / 100;

        priceElement.textContent = Rebuy.SmartCart.formatMoney(finalLinePrice);
        total = total + finalLinePrice;
      }
    });
    var cartTotalElement = document.querySelector('.rebuy-cart__flyout-subtotal-amount');
    cartTotalElement.textContent = Rebuy.SmartCart.formatMoney(total);
  }
}

document.addEventListener("rebuy:smartcart.show", (event) => {
  console.log(9)
  setTimeout(function () {
    modifyCartPricesAndTotal();
    hideSubscriptionForTryBeforeYouBuy();
  }, 500);
});

document.addEventListener("rebuy:cart.change", (event) => {
  console.log(0)
  setTimeout(function () {
    modifyCartPricesAndTotal();
    hideSubscriptionForTryBeforeYouBuy();
  }, 500);
});

//Yotpo and TBYB modifications
document.addEventListener("DOMContentLoaded", function () {
  // Hide TBYB when clicking subscription
  const newFunction = () => {
    var checkSubscriptionRadios = setInterval(function () {
      var subscriptionRadios = document.querySelectorAll('.yotpo-selling-plans input[type=radio]');

      if (subscriptionRadios.length > 0) {
        for (var i = 0; i < subscriptionRadios.length; i++) {
          subscriptionRadios[i].addEventListener('click', function () {
            if (this.value) {
              document.getElementById("payTodayPurchaseOption").click();
              document.getElementById("blackcartTbyb").style.display = "none";
            } else {
              document.getElementById("blackcartTbyb").style.display = "block";
              document.getElementById("tbybPurchaseOption").click();
            }
          });
        }
        clearInterval(checkSubscriptionRadios);
      }
    }, 100);
  }

// Disable TBYB when clicking variant that doesn't have selling plan
  var checkTbybRadios = setInterval(function () {
    var tbybRadios = document.querySelectorAll('fieldset.swatch.is-flex.is-flex-wrap input[type=radio]');

    if (tbybRadios.length > 0) {
      for (var i = 0; i < tbybRadios.length; i++) {
        tbybRadios[i].addEventListener('change', function () {
          document.getElementById("blackcartTbyb").style.display = "block";
          if (this.value === 'Travel Size' || this.value === '3 Month Supply') {
            document.getElementById("tbybPurchaseOption").disabled = true;
            document.getElementById("payTodayPurchaseOption").click();
          } else {
            document.getElementById("tbybPurchaseOption").disabled = false;
          }
          setTimeout(newFunction, 500);
        });
      }
      clearInterval(checkTbybRadios);
    }
  }, 100);

  newFunction();
});

function hideSubscriptionForTryBeforeYouBuy() {
  console.log('hideSubscriptionForTryBeforeYouBuy ----------------------------------- ');
  // Select all cart items
  const cartItems = document.querySelectorAll('.rebuy-cart__flyout-item');

  console.log('cartItems length = ', cartItems.length);
  
  cartItems.forEach(item => {
    // Check if the item has "Try Before You Buy" text
    const isTryBeforeYouBuy = item.textContent.includes('Try Before You Buy');

    console.log('isTryBeforeYouBuy = ', isTryBeforeYouBuy);
    
    // Find the subscription dropdown within this item
    const subscriptionDropdown = item.querySelector('.rebuy-cart__flyout-item-subscription');
    
    if (subscriptionDropdown) {
      if (isTryBeforeYouBuy) {
        // Hide the subscription dropdown for Try Before You Buy items
        subscriptionDropdown.style.display = 'none';
      } else {
        // Show the subscription dropdown for other items
        subscriptionDropdown.style.display = 'block';
      }
    }
  });
}
// Run the function when the page loads and whenever the cart updates
document.addEventListener('DOMContentLoaded', hideSubscriptionForTryBeforeYouBuy);
document.addEventListener('rebuy:cart.change', hideSubscriptionForTryBeforeYouBuy);

